import { motion } from 'framer-motion';
// material
import { styled } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
// hooks
import useAuth from '../hooks/useAuth';
// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';
import { MaintenanceIllustration } from '../assets';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const isRejected = user?.candidate?.approvalStatus === 'REJECTED';

  return (
    <RootStyle title="Cadastro em análise | CREA">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                {isRejected ? 'Cadastro não aprovado' : 'Cadastro em análise'}
              </Typography>
            </motion.div>

            <Typography sx={{ color: 'text.secondary' }}>
              {isRejected
                ? 'Infelizmente seu cadastro não foi aprovado pela administração do CREA. Caso acredite que houve um engano, entre em contato com o suporte.'
                : 'Recebemos seu cadastro! Ele está aguardando a aprovação da administração do CREA. Assim que for aprovado, você terá acesso completo à plataforma. Você pode tentar entrar novamente mais tarde.'}
            </Typography>

            <motion.div variants={varBounceIn}>
              <MaintenanceIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </motion.div>

            <Button size="large" variant="contained" onClick={logout}>
              Sair
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
